var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{class:_vm.value ? 'text-success' : 'text-gray-400',attrs:{"icon":_vm.value ? 'check' : 'times'}})}
var staticRenderFns = []

export { render, staticRenderFns }